import { ExternalToolCard } from '../ExternalToolCard';
import type { ExternalToolDto } from '@/entities/external-tool';

interface ExternalToolsGridProps {
  externalTools: ExternalToolDto[];
  onClick?: (externalTool: ExternalToolDto) => void;
}

export function ExternalToolsGrid({ externalTools, onClick }: ExternalToolsGridProps) {
  return (
    <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-6">
      {externalTools.map(
        (tool) =>
          tool.isVisible && (
            <ExternalToolCard key={tool.id} externalTool={tool} onClick={onClick} />
          ),
      )}
    </div>
  );
}
